import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import FormControlLabel from 'dashboard/components/FormControls/FormControlLabel';
import Select, { Option } from 'design-system/components/Select';
import { Theme } from 'verify/models/theme';

const Container = styled('div')`
  padding-top: ${Spacing[6]};
  padding-left: ${Spacing[4]};
  padding-right: ${Spacing[4]};
`;

interface ThemeSelectorProps {
  themes: Theme[];
  themeSelectedPristine: Theme;
  handleThemeSelect: (themeId: string) => void;
}

const ThemeSelector = (props: ThemeSelectorProps) => {
  if (props.themes.length > 1) {
    return (
      <Container data-test='theme-selector'>
        <FormControlLabel>Theme</FormControlLabel>
        <Select
          value={props.themeSelectedPristine.id}
          onValueChange={(value) => props.handleThemeSelect(value)}
        >
          {props.themes.map((theme) => (
            <Option key={theme.id} value={theme.id}>
              {theme.attributes.name}
            </Option>
          ))}
        </Select>
      </Container>
    );
  } else {
    return <div />;
  }
};

export default ThemeSelector;
